import React, { useState } from "react";
import "../css/style.css";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RQUseQuery } from "../components/RQUseQueryHook.ts";

interface Sana {
  currencyName: string;
  havaleType: string;
  // unitPrice:string;
  // wage:string;
  // endUnitPrice:string;
  supply: string;
  resource: string;
}
function CurrencyList() {
  const [sanaData, setSanaData] = useState<Array<Sana>>();

  const tblRow = ["نوع ارز", "نوع حواله", "کل موجودی", "منشأ"];
  const tblRow2 = [
    "نوع ارز",
    "نوع حواله",
    "قیمت واحد",
    "کارمزد",
    "بهای تمام شده هر واحد",
    "کل موجودی",
    "منشأ",
  ];

  const onSuccess = (data) => {
    let tempData: Sana[] = [];
    for (let i = 0; i < data.data.sanaOutput[0]?.table.length; i++) {
      tempData[i] = {
        currencyName: "",
        havaleType: "",
        // unitPrice:'',
        // wage:'',
        // endUnitPrice:'',
        supply: "",
        resource: "",
      };
      tempData[i].currencyName = data.data.sanaOutput[0].table[i][tblRow[0]];
      tempData[i].havaleType = data.data.sanaOutput[0].table[i][tblRow[1]];
      tempData[i].supply = data.data.sanaOutput[0].table[i][tblRow[2]];
      tempData[i].resource = data.data.sanaOutput[0].table[i][tblRow[3]];
    }
    setSanaData(tempData);
  };
  const onError = (err) => {
    console.log(err);
  };
  RQUseQuery(
    "https://charismaex.ir:200/api/Report/GetCurrencyRate",
    "CurrencyRates",
    true,
    false,
    onSuccess,
    onError
  );

  const checkCurrencyType = (currency) => {
    switch (currency) {
      case "یورو":
        return "(Euro)";
      // x.style.display='flex';
      // x.style.flexDirection='column';
      case "دلار":
        return "(Dollar)";
      // x.style.display='flex';
      // x.style.flexDirection='column';
      case "یوان":
        return "(Yuan)";
      // x.style.display='flex';
      // x.style.flexDirection='column';
      case "روبل":
        return "(Ruble)";
      // x.style.display='flex';
      // x.style.flexDirection='column';
      case "روپیه":
        return "(Rupee)";
      // x.style.display='flex';
      // x.style.flexDirection='column';

      case "درهم":
        return "(dirham)";
      // x.style.display='flex';
      // x.style.flexDirection='column';
      default:
        break;
    }
  };
  return (
    <div className="container">
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <TableContainer
          component={Paper}
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "fit-content",
          }}
        >
          <Table sx={{ width: "65rem" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {tblRow.map(
                  (x, idx) => (
                    <TableCell className="ratesTh" key={idx} align="right">
                      {x}
                    </TableCell>
                  )
                  // <th className='th' key={idx}>{x}</th>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {sanaData?.map((x, index) => (
                <TableRow
                  className="ratesTr"
                  key={index}
                  sx={{ "&:last-child , &:last-child": { border: 0 } }}
                >
                  {Object.values(x).map((tr, trIndex) => (
                    <TableCell className="ratesTd" key={trIndex} align="right">
                      {trIndex === 0 ? checkCurrencyType(x.currencyName) : null}
                      {tr ? tr : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default CurrencyList;
